import styled from '@emotion/styled'
import { Grid, CircularProgress as MuiCircularProgress } from '@material-ui/core'

import { Button } from 'components/inputs/Button/Button'

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing(3)}px;
`

interface SearchElementProps {
  $maxWidth?: string
  $grow?: boolean
}

const SearchElement = styled(Grid, {
  shouldForwardProp: (prop) => prop !== '$maxWidth' && prop !== '$grow',
})<SearchElementProps>`
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth};`}
  ${({ $grow }) => typeof $grow === 'boolean' && `flex-grow: ${$grow ? '1' : '0'};`}
`

const StyledButton = styled(Button)`
  margin: ${({ theme }) => theme.spacing(1, 2, 1, 0)};
  width: 215px;
  font-size: 15px;
  white-space: nowrap;
`

const CardsListContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(3, 0)};
`

const CircularProgress = styled(MuiCircularProgress)`
  margin: ${({ theme }) => theme.spacing(2, 'auto')};
`

const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
`

export {
  Container,
  StyledButton as Button,
  CardsListContainer,
  CircularProgress,
  LoadMoreContainer,
  SearchElement,
}
